import { useAppDispatch, useAppSelector } from '@shared/hooks';
import type { Event } from '@src/library/models/events';
import { selectEvents, setEvents } from '@src/library/redux/events';

export const useEvents = () => {
  const dispatch = useAppDispatch();
  const addEvents = (events: Event[]) => dispatch(setEvents(events));

  const events = useAppSelector(selectEvents).list;

  return {
    addEvents,
    events,
  };
};
